export const TOGGLE_STORES = 'TOGGLE_STORES';
export const FILTER_STORES = 'FILTER_STORES';
export const GET_STORES = 'GET_STORES';
export const SET_STORES = 'SET_STORES';
export const SET_STORES_ERROR = 'SET_STORES_ERROR';
export const SET_ALL_STORES = 'SET_ALL_STORES';
